import partyArea from './party/index';
import SearchInput from './SearchInput/index';
import Cookies from 'js-cookie';
import { minFestival, bigFestival } from './cisFeed/festival';

const JS = {
    init() {
        // 执行右上角党模块的动画切换
        partyArea.init();
        // 搜索框的内容替换
        const searchInput = new SearchInput({
            $el:document.querySelector('.input_SearchInput'),
            interval:10000,
            list:document.querySelector('.input_SearchInput').getAttribute('data-hotsearch').split(',') || []
        })
        searchInput.start();
        const noSetUrl = "http://statics.itc.cn/sohu-homepage/classicentrance.png";
        const setUrl = "http://statics.itc.cn/sohu-homepage/classicentranceclick.png";
        document.querySelector('.img_HomePage').addEventListener('click',function(){
            if (this.getAttribute('src') === noSetUrl) {
                // 没有设置变成设置
                Cookies.set('isFromClassic', 'true', {expires: 3,domain: '.sohu.com'});
                document.querySelector('.entrance_UserReport').style.display='none';
                this.setAttribute('class','img_HomePage cancle-img_HomePage');
                this.setAttribute('src',setUrl);
                document.querySelector('.alert_HomePage').style.display='block';
                window.sohuSpm.sendAction({
                    acode: '8743',
                    clkParam: 'position:0'
                });
                setTimeout(function(){
                    document.querySelector('.alert_HomePage').style.display='none';
                },3000);
            }else {
                if (this.getAttribute('src') === "http://statics.itc.cn/sohu-homepage/classicentranceclick.png") {
                    // 取消默认设置
                    Cookies.set('isFromClassic', 'false', {expires: 3,domain: '.sohu.com'});
                    document.querySelector('.entrance_UserReport').style.display='block';
                    this.setAttribute('class','img_HomePage set-img_HomePage');
                    this.setAttribute('src',noSetUrl);
                    window.sohuSpm.sendAction({
                        acode: '8744'
                    });
                }
            }
        },false);
        const headerDom =  document.querySelector('.img_HomePage');
        document.querySelector('.entrance_UserReport').addEventListener('click',function(){
            Cookies.set('isFromClassic', 'true', {expires: 3,domain: '.sohu.com'});
            this.style.display='none';
            headerDom.setAttribute('class','img_HomePage cancle-img_HomePage');
            document.querySelector('.img_HomePage').setAttribute('src',"http://statics.itc.cn/sohu-homepage/classicentranceclick.png");
            document.querySelector('.alert_HomePage').style.display='block';
            setTimeout(function(){
                document.querySelector('.alert_HomePage').style.display='none';
            },3000);
            window.sohuSpm.sendAction({
                acode: '8743',
                clkParam: 'position:1'
            });
        },false);
        const mode = Cookies.get('isFromClassic');
        if (mode === 'true') {
            document.querySelector('.img_HomePage').setAttribute('src',setUrl);
            headerDom.setAttribute('class','img_HomePage cancle-img_HomePage');
            document.querySelector('.entrance_UserReport').style.display='none';
        } else {
            document.querySelector('.img_HomePage').setAttribute('src',noSetUrl);
            headerDom.setAttribute('class','img_HomePage set-img_HomePage');
        };
        //大皮肤
        bigFestival();
        //微皮肤
        minFestival();
    }
}
export default JS;


// WEBPACK FOOTER //
// ./src/JS/index.js